import { isMissingValuePlaceholder } from './isMissingValuePlaceholder';

export const isMinorArrearsFormatting = (
  value: string,
  isMinorArrears: boolean,
) => {
  const updatedValue = isMissingValuePlaceholder(value);
  return isMinorArrears ? `(${updatedValue})` : updatedValue;
};
